// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* Breakpoints */
.ant-notification {
  z-index: 20000;
}
.button-module__button_template--Dx9dX {
  min-width: 80px;
  min-height: 32px;
  border-radius: 4px;
  margin: 0 !important;
  margin: 0 16px;
  height: auto;
  padding: 4px 16px;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
}
.button-module__button_template--Dx9dX.ant-btn-sm {
  padding: 0 16px;
  min-width: 60px;
  min-height: initial;
  font-size: 13px;
  font-weight: 300;
}
.button-module__button_template--Dx9dX.ant-btn-lg {
  min-height: 42px;
}
.button-module__button_template--Dx9dX *:disabled {
  background-color: red !important;
}
.button-module__button_template--Dx9dX.button-module__icon--KrQUT {
  min-width: initial;
  border: 0;
  color: rgba(0, 0, 0, 0.45);
}
.button-module__button_template--Dx9dX.button-module__icon--KrQUT:hover {
  border: 0;
}
.button-module__button_template--Dx9dX.button-module__icon--KrQUT svg {
  width: 1.2em;
  height: 1.2em;
}
.button-module__button_template--Dx9dX.button-module__icon--KrQUT.ant-btn-sm {
  padding: initial;
  min-width: initial;
  font-size: 13px;
  font-weight: 300;
}
.button-module__button_template--Dx9dX.ant-btn-default {
  background-color: transparent;
}
.button-module__button_template--Dx9dX.ant-btn-default:active:enabled,
.button-module__button_template--Dx9dX.ant-btn-default:focus:enabled,
.button-module__button_template--Dx9dX.ant-btn-default:hover:enabled {
  background-color: #90d5dd;
  border: 1px solid #90d5dd;
  color: #222629;
}
.button-module__button_template--Dx9dX.ant-btn-primary {
  background-color: #72bc75;
  color: white;
  font-weight: 500;
  border: 0px solid #72bc75;
}
.button-module__button_template--Dx9dX.ant-btn-primary:active:enabled,
.button-module__button_template--Dx9dX.ant-btn-primary:focus:enabled,
.button-module__button_template--Dx9dX.ant-btn-primary:hover:enabled {
  background-color: #51aa54;
}
@media only screen and (max-width: 767px) {
  .button-module__button_template--Dx9dX {
    padding: 4px 8px;
    font-size: 13px;
  }
}
.button-module__wrapper--k6XdC {
  min-width: 80px;
  min-height: 32px;
  border-radius: 4px;
  margin: 0 !important;
  margin: 0 16px;
  height: auto;
  padding: 4px 16px;
  font-size: 13px;
  font-weight: 400;
  text-transform: uppercase;
}
.button-module__wrapper--k6XdC.ant-btn-sm {
  padding: 0 16px;
  min-width: 60px;
  min-height: initial;
  font-size: 13px;
  font-weight: 300;
}
.button-module__wrapper--k6XdC.ant-btn-lg {
  min-height: 42px;
}
.button-module__wrapper--k6XdC *:disabled {
  background-color: red !important;
}
.button-module__wrapper--k6XdC.button-module__icon--KrQUT {
  min-width: initial;
  border: 0;
  color: rgba(0, 0, 0, 0.45);
}
.button-module__wrapper--k6XdC.button-module__icon--KrQUT:hover {
  border: 0;
}
.button-module__wrapper--k6XdC.button-module__icon--KrQUT svg {
  width: 1.2em;
  height: 1.2em;
}
.button-module__wrapper--k6XdC.button-module__icon--KrQUT.ant-btn-sm {
  padding: initial;
  min-width: initial;
  font-size: 13px;
  font-weight: 300;
}
.button-module__wrapper--k6XdC.ant-btn-default {
  background-color: transparent;
}
.button-module__wrapper--k6XdC.ant-btn-default:active:enabled,
.button-module__wrapper--k6XdC.ant-btn-default:focus:enabled,
.button-module__wrapper--k6XdC.ant-btn-default:hover:enabled {
  background-color: #90d5dd;
  border: 1px solid #90d5dd;
  color: #222629;
}
.button-module__wrapper--k6XdC.ant-btn-primary {
  background-color: #72bc75;
  color: white;
  font-weight: 500;
  border: 0px solid #72bc75;
}
.button-module__wrapper--k6XdC.ant-btn-primary:active:enabled,
.button-module__wrapper--k6XdC.ant-btn-primary:focus:enabled,
.button-module__wrapper--k6XdC.ant-btn-primary:hover:enabled {
  background-color: #51aa54;
}
@media only screen and (max-width: 767px) {
  .button-module__wrapper--k6XdC {
    padding: 4px 8px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./components/atoms/button/button.module.less","webpack://./styles/variables.less","webpack://./styles/mixins/button.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,gBAAgB;AC0JhB;EACE,cAAA;ADxJF;AEJA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AFMF;AEJE;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AFMJ;AEHE;EACE,gBAAA;AFKJ;AE1BA;EAyBI,gCAAA;AFIJ;AEAE;EACE,kBAAA;EACA,SAAA;EACA,0BAAA;AFEJ;AEAI;EACE,SAAA;AFEN;AERE;EAUI,YAAA;EACA,aAAA;AFCN;AEEI;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AFAN;AEKE;EACE,6BAAA;AFHJ;AEKI;;;EAGE,yBAAA;EACA,yBAAA;EACA,cAAA;AFHN;AEOE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AFLJ;AEOI;;;EAGE,yBAAA;AFLN;AESE;EAAA;IACE,gBAAA;IACA,eAAA;EFNF;AACF;AA1EA;EECE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AF4EF;AE1EE;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AF4EJ;AEzEE;EACE,gBAAA;AF2EJ;AAhGA;EEyBI,gCAAA;AF0EJ;AEtEE;EACE,kBAAA;EACA,SAAA;EACA,0BAAA;AFwEJ;AEtEI;EACE,SAAA;AFwEN;AE9EE;EAUI,YAAA;EACA,aAAA;AFuEN;AEpEI;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AFsEN;AEjEE;EACE,6BAAA;AFmEJ;AEjEI;;;EAGE,yBAAA;EACA,yBAAA;EACA,cAAA;AFmEN;AE/DE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AFiEJ;AE/DI;;;EAGE,yBAAA;AFiEN;AE7DE;EAAA;IACE,gBAAA;IACA,eAAA;EFgEF;AACF","sourcesContent":["@import '../../../styles/variables.less';\n@import '../../../styles/mixins/button.less';\n\n.wrapper {\n  .button_template;\n}\n","@import '~antd/lib/style/themes/default.less';\n@import './breakpoints.less';\n\n// Font\n@font-family: 'Roboto', 'Oswald', BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n  'Noto Color Emoji';\n\n// Color palette\n// Cores Primárias\n@primary-100: #91cc92;\n@primary-200: #67bf65;\n@primary-300: #3cb638;\n@primary-400: #2d8d2c;\n@primary-500: #1B752B; // Cor original\n@primary-600: #165e25;\n@primary-700: #10461f;\n@primary-800: #0b2f19;\n@primary-900: #051912;\n\n// Cores Secundárias\n@secondary-100: #90a8d4;\n@secondary-200: #668bc1;\n@secondary-300: #3d6eaf;\n@secondary-400: #2f5c9f;\n@secondary-500: #2B4675; // Cor original\n@secondary-600: #23405e;\n@secondary-700: #1b3948;\n@secondary-800: #122a31;\n@secondary-900: #091c1b;\n\n// Cores Terciárias\n@tertiary-100: #d48f90;\n@tertiary-200: #c16667;\n@tertiary-300: #af3e3f;\n@tertiary-400: #9f2d2f;\n@tertiary-500: #752B1B; // Cor original\n@tertiary-600: #5e2424;\n@tertiary-700: #46201b;\n@tertiary-800: #2f180f;\n@tertiary-900: #1c0c05;\n\n// Cores de Erro\n@error-100: #d49090;\n@error-200: #c16767;\n@error-300: #af3f3f;\n@error-400: #9f2e2e;\n@error-500: #751B2B; // Cor original\n@error-600: #5e2424;\n@error-700: #461e1e;\n@error-800: #2f1515;\n@error-900: #1c0909;\n\n// Cores de Aviso\n@warning-100: #d4d490;\n@warning-200: #c1c167;\n@warning-300: #afaf3f;\n@warning-400: #9f9f2d;\n@warning-500: #75751B; // Cor original\n@warning-600: #5e5e15;\n@warning-700: #46461e;\n@warning-800: #2f2f15;\n@warning-900: #1c1c09;\n\n// Cores de Informação\n@info-100: #90d4d4;\n@info-200: #67c1c1;\n@info-300: #3fafaf;\n@info-400: #2d9f9f;\n@info-500: #1B7575; // Cor original\n@info-600: #155e5e;\n@info-700: #0f4646;\n@info-800: #092f2f;\n@info-900: #051c1c;\n\n// Cinza\n@gray-100: #d4d4d4;\n@gray-200: #c1c1c1;\n@gray-300: #afafaf;\n@gray-400: #9f9f9f;\n@gray-500: #757575; // Cor original\n@gray-600: #5e5e5e;\n@gray-700: #464646;\n@gray-800: #2f2f2f;\n@gray-900: #1c1c1c;\n\n\n// Colors\n@v2-color-primary: rgb(144, 213, 221);\n@v2-color-secondary: #72bc75;\n@green-300: rgb(137, 235, 155);\n@green-400: rgb(29, 147, 51);\n@green-500: rgb(27, 117, 43);\n@red-500: rgb(128,0,0);\n@red-400: #B00020;\n@red-300: #f77777;\n@yellow-500: rgb(204, 148, 74);\n\n@font-size-mobile: 13px;\n@font-size-base: 13px;\n\n@title-font-size: 32px;\n@title-color: @green-500;\n\n@separator: #f0f0f0;\n@oddColor: #efefef;\n\n@subtitle-font-size: 22px;\n@subtitle-color: rgb(0, 65, 75);\n\n@bg-menu-lateral: rgb(0, 65, 75);\n@icon-menu-sup-color: rgb(61, 197, 86);\n@label-color: rgb(8, 108, 124);\n\n@header-color: #005866;\n@table-header-color: #005866;\n\n// Shadows\n@v2-bg-card-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n@v2-bg-label-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);\n@v2-bg-overlay-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);\n@v2-bg-card-mobile-shadow: 0px 0px 5px 0px rgba(0,0,0,0.30);\n\n// Backgrounds\n@bg-color: #ffffff;\n\n// Text colors\n@text-color: #454545;\n@input-color: #333;\n\n// Dev colors\n@dev-background: #444;\n@dev-button-hover: #222;\n@v2-bg-card: rgba(255,255,255,0.1);\n\n\n\n// Sizes\n@header-height: 60px;\n@menu-width: 200px;\n\n// V2\n@v2-bg-color: #222629;\n\n\n@bg-card: #37393B;\n@dashboard-page: lighten(@bg-color, 20%);\n\n// Titles\n@v2-menu-title: #ddd;\n\n// Menu\n@v2-text-color: @text-color;\n@v2-text-color-hover: #ccc;\n\n// Animations\n@animation-time: 450ms;\n\n:global(.ant-notification) {\n  z-index: 20000;\n}\n","@import '../variables.less';\n@import '../breakpoints.less';\n\n.button_template {\n  min-width: 80px;\n  min-height: 32px;\n  border-radius: 4px;\n  margin: 0 !important;\n  margin: 0 16px;\n  height: auto;\n  padding: 4px 16px;\n  font-size: @font-size-base;\n  font-weight: 400;\n  text-transform: uppercase;\n\n  &:global(.ant-btn-sm) {\n    padding: 0 16px;\n    min-width: 60px;\n    min-height: initial;\n    font-size: 13px;\n    font-weight: 300;\n  }\n\n  &:global(.ant-btn-lg) {\n    min-height: 42px;\n  }\n\n  *:disabled {\n    background-color: red !important;\n  }\n\n\n  &.icon {\n    min-width: initial;\n    border: 0;\n    color: @text-color-secondary;\n\n    &:hover {\n      border: 0;\n    }\n\n    svg {\n      width: 1.2em;\n      height: 1.2em;\n    }\n\n    &:global(.ant-btn-sm) {\n      padding: initial;\n      min-width: initial;\n      font-size: 13px;\n      font-weight: 300;\n    }\n  }\n\n\n  &:global(.ant-btn-default) {\n    background-color: transparent;\n\n    &:active:enabled,\n    &:focus:enabled,\n    &:hover:enabled {\n      background-color: @v2-color-primary;\n      border: 1px solid @v2-color-primary;\n      color: @v2-bg-color;\n    }\n  }\n\n  &:global(.ant-btn-primary) {\n    background-color: @v2-color-secondary;\n    color: white;\n    font-weight: 500;\n    border: 0px solid @v2-color-secondary;\n\n    &:active:enabled,\n    &:focus:enabled,\n    &:hover:enabled {\n      background-color: darken(@v2-color-secondary, 10);\n    }\n  }\n\n  @media @tabletM {\n    padding: 4px 8px;\n    font-size: @font-size-mobile;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ant-notification": `ant-notification`,
	"antNotification": `ant-notification`,
	"button_template": `button-module__button_template--Dx9dX`,
	"buttonTemplate": `button-module__button_template--Dx9dX`,
	"ant-btn-sm": `ant-btn-sm`,
	"antBtnSm": `ant-btn-sm`,
	"ant-btn-lg": `ant-btn-lg`,
	"antBtnLg": `ant-btn-lg`,
	"icon": `button-module__icon--KrQUT`,
	"ant-btn-default": `ant-btn-default`,
	"antBtnDefault": `ant-btn-default`,
	"ant-btn-primary": `ant-btn-primary`,
	"antBtnPrimary": `ant-btn-primary`,
	"wrapper": `button-module__wrapper--k6XdC`
};
export default ___CSS_LOADER_EXPORT___;
